import { fullCaseReset } from "../App";
import {
  EDITING,
  WAITING_FOR_FILES,
  NORMALIZING,
  NORMALIZING_FAILED,
  NORMALIZING_FILTER,
  FILTERING,
  TRIMMING,
  EXTRACTING,
  COPYING,
  GLIMPSE_QUEUED,
  GLIMPSE_RUNNING,
  GLIMPSE_COMPLETE,
  NOISE_FILTERING,
  NOISE_FILTER_RUNNING,
  NOISE_FILTERING_QUEUED,
  UPLOAD_ERROR,
  GLIMPSE_ERROR,
  SYNC_FILTERING_QUEUED,
  SYNC_FILTER_RUNNING,
  ASI_FILTER_COMPLETE,
  NLMS_FILTER_COMPLETE,
  ASI_FILTER_QUEUED,
  ASI_FILTER_RUNNING,
  NLMS_FILTER_QUEUED,
  NLMS_FILTER_RUNNING,
  BECOMING_SINGLE_CHANNEL,
} from "./statuses";

const ROOT_URL = `/app/cases/`; // default route;

export const checkStatusWhitelist = (clip, statuses) => {
  if (typeof statuses === "string") {
    statuses = [statuses];
  }
  console.log(statuses);
  return statuses.some((status) => status === clip.status);
};

const getClipUrl = (caseId, clipId, clipStatus) => {
  let url = `${ROOT_URL}${caseId}/clips/${clipId}/`;

  switch (clipStatus) {
    case EDITING: {
      url += "editor";
      break;
    }
    case WAITING_FOR_FILES: {
      // TODO: Select files on failed upload
      url += "addFiles";
      break;
    }
    case NORMALIZING: {
      url += "normalizing";
      break;
    }
    case BECOMING_SINGLE_CHANNEL:
    case ASI_FILTER_QUEUED:
    case ASI_FILTER_RUNNING:
    case NLMS_FILTER_QUEUED:
    case NLMS_FILTER_RUNNING:
    case TRIMMING:
    case EXTRACTING:
    case NORMALIZING_FILTER:
    case SYNC_FILTERING_QUEUED:
    case SYNC_FILTER_RUNNING:
    case FILTERING: {
      url += "filtering";
      break;
    }

    case COPYING: {
      // TODO: What is this now?
      url += "audioUpload/copying";
      break;
    }

    case GLIMPSE_QUEUED:
    case GLIMPSE_RUNNING: {
      url += "glimpse/running";
      break;
    }
    case ASI_FILTER_COMPLETE:
    case NLMS_FILTER_COMPLETE:
    case GLIMPSE_COMPLETE: {
      url += "filtered/output";
      break;
    }

    case NOISE_FILTERING: {
      url += "noiseFiltering";
      break;
    }
    case NOISE_FILTER_RUNNING:
    case NOISE_FILTERING_QUEUED: {
      url += "noiseFiltering/running";
      break;
    }
    case UPLOAD_ERROR: {
      url += "uploadError";
      break;
    }
    case GLIMPSE_ERROR: {
      url += "glimpse/error";
      break;
    }
    case NORMALIZING_FAILED:
    default: {
      url = `${ROOT_URL}${caseId}/clips`;
      break;
    }
  }
  return url;
};

export const getNavigationUrl = (af_case, clip) => {
  if (clip && clip.caseId && clip.id) {
    return getClipUrl(clip.caseId, clip.id, clip.status);
  } else if (af_case) {
    const caseId = typeof af_case === "object" ? af_case.id : af_case;
    return `${ROOT_URL}${caseId}/clips`; // af_case should be null if clip is filled in
  } else {
    //No clip or case defined
    return `${ROOT_URL}`;
  }
};

export const navigateToClip = async (
  dispatch,
  navigate,
  caseId,
  clipId,
  clipStatus,
) => {
  if (caseId === undefined || caseId === "undefined") return;
  if (clipId === undefined || clipId === "undefined") return;
  console.log("[navigateToClip] >>>>> " + clipId + " " + clipStatus);
  await fullCaseReset(dispatch);
  const url = getClipUrl(caseId, clipId, clipStatus);
  navigate(url);
};
